import React, { useEffect, useRef, useState } from "react"
import { PageSection } from "@components/sections"
import Styles from "./dropdownCopy.module.scss"

const DropdownCopy = ({ data }) => {
  const { collapsed, id, label, content } = data
  const body = content.childMarkdownRemark.html
  const contentElemId = `dropdown-content-${id}`
  const [isDropdownOpen, setIsDropdownOpen] = useState(collapsed)
  const [height, setHeightState] = useState("0px")

  const contentElem = useRef(null)

  const toggleDropdown = () => {
    const active = !isDropdownOpen
    setIsDropdownOpen(active)
    setHeightState(active ? "0px" : `${contentElem.current.scrollHeight + 100}px`)
  }

  useEffect(() => {
    if (contentElem.current !== null) toggleDropdown()
  }, [contentElem.current])

  useEffect(() => {
    const myElement = document.getElementById(contentElemId)
    myElement.innerHTML = body
  }, [])

  return (
    <PageSection className={Styles.section}>
      <div className={Styles.accordionSection}>
        <button type="button" className={Styles.accordionBtn} onClick={toggleDropdown}>
          <div className={Styles.accordionTitle}>{label}</div>
          <div className={Styles.icon}>+</div>
        </button>
        <div
          ref={contentElem}
          style={{ maxHeight: `${height}` }}
          className={Styles.accordionContent}
          id={contentElemId}
        />
      </div>
    </PageSection>
  )
}

export default DropdownCopy
